<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTable',title:'销售样表'},{title:'新增销售样表'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>新增销售样表</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Yangbiao">
                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="prodcode">

                                                <el-input placeholder="请输入" v-model="f.prodcode"  @change="selectModel"></el-input>
                                                <!--   <el-select class="h-tableInput" filterable v-model="f.prodcode"  clearable  @change="selectListByCode">
                                                       <el-option v-for="(item,index) in wuliao" :key="index" :label="item.materialCode" :value="item.materialCode">
                                                       </el-option>
                                                   </el-select>-->
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="promodel">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.promodel" readonly></el-input>
                                                <!--   <el-select class="h-tableInput" filterable v-model="f.promodel"  clearable  @change="clickmodel">
                                                       <el-option v-for="(item,index) in wuliao" :key="index" :label="item.materialDescrition" :value="item.materialDescrition">
                                                       </el-option>
                                                   </el-select>-->
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="prodseries">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.prodseries" readonly></el-input>
                                                <!--<el-select v-model="f.prodseries" :v="f.prodseries"  placeholder="请选择">
                                                    <el-option v-for="(item,index) in LevelName"
                                                               :key="index+1"
                                                               :label="item.levelname"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>-->
                                            </el-form-item>


                                            <el-form-item label="型号经理" class="h-elformWrap-2">
                                                <el-input placeholder="请输入型号经理工号" v-model="f.userCode" :disabled="updateFlag"></el-input>
                                            </el-form-item>
                                          <!--  <el-form-item label="状态" class="h-elformWrap-2" prop="prodstatus">
                                                <brselect category="prodstatus" :v="f.prodstatus"
                                                          v-model="f.prodstatus"/>
                                            </el-form-item>-->
                                            <el-form-item label="型号属性" class="h-elformWrap-2" prop="protype">
                                                <el-select v-model="f.protype" :disabled="updateFlag" placeholder="请选择">
                                                    <el-option value="自产">自产</el-option>
                                                    <el-option value="OEM">OEM</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="二类是否覆盖6858" class="h-elformWrap-2" prop="have6858">
                                                <brselect category="permit" :v="f.have6858" :disabled="updateFlag" v-model="f.have6858"/>
                                            </el-form-item>
                                            <el-form-item label="二类是否覆盖6840" class="h-elformWrap-2" prop="have6840">
                                                <brselect category="permit" :v="f.have6840" :disabled="updateFlag" v-model="f.have6840"/>
                                            </el-form-item>
                                            <el-form-item label="三类是否覆盖6854" class="h-elformWrap-2" prop="have6854">
                                                <brselect category="permit" :v="f.have6854" :disabled="updateFlag" v-model="f.have6854"/>
                                            </el-form-item>
                                            <el-form-item label="三类是否覆盖6840" class="h-elformWrap-2" prop="three6840">
                                                <brselect category="permit" :v="f.three6840" :disabled="updateFlag" v-model="f.three6840"/>
                                            </el-form-item>
                                            <el-form-item label="公司名称" class="h-elformWrap-2" prop="companycode">
                                                <brselect category="xsyb_gongsi" :v="f.companycode"
                                                          v-model="f.companycode"/>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                                                <el-input placeholder="定价后自动带出" v-model="f.factory" disabled></el-input>
                                            </el-form-item>
                                            <el-form-item label="类别" class="h-elformWrap-2" prop="sort">
                                                <el-select v-model="f.sort" :disabled="updateFlag" placeholder="请选择">
                                                    <el-option value="三高">三高</el-option>
                                                    <el-option value="三生">三生</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="有效期" class="h-elformWrap-2" prop="validperiod">
                                                <el-date-picker placeholder="请选择"
                                                                v-model="f.validperiod"
                                                                :disabled="updateFlag"
                                                                value-format="yyyy-MM-dd"
                                                                :clearable="false"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="是否计入销额" class="h-elformWrap-2" prop="xiaoe">
                                                <brselect placeholder="定价后自动带出" category="xiaoe_jishu" disabled :v="f.xiaoe" v-model="f.xiaoe"></brselect>
                                            </el-form-item>
                                            <el-form-item label="是否计入基数" class="h-elformWrap-2" prop="jishu">
                                                <brselect placeholder="定价后自动带出" category="xiaoe_jishu" disabled :v="f.jishu" v-model="f.jishu"></brselect>
                                            </el-form-item>
                                            <el-form-item label="链群" class="h-elformWrap-2" prop="lianqun">
                                                <brselectlazy category="xsyb_lianqun" v-model="f.lianqun" :disabled="updateFlag"
                                                              :v="f.lianqun"></brselectlazy>
                                            </el-form-item>
                                            <el-form-item label="子链群" class="h-elformWrap-2" prop="lianqunchild">
                                                <brselect category="xsyb_lianqunchild" v-model="f.lianqunchild" :clearable="true"
                                                          :disabled="updateFlag"
                                                            :v="f.lianqunchild"></brselect>

                                            </el-form-item>
                                            <el-form-item label="渠道专供" class="h-elformWrap-2">
                                                <brselectlazy :multiple="true" category="sales_region" :disabled="updateFlag" :v="f.channel" v-model="f.channel"/>
                                            </el-form-item>

                                            <el-form-item label="是否服务产品" class="h-elformWrap-2" prop="isFw">
                                                <el-select v-model="f.isFw" :v="f.isFw" :disabled="updateFlag" placeholder="请选择">
                                                    <el-option v-for="(item) in fwList"
                                                               :key="item.code"
                                                               :label="item.name"
                                                               :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>


                                            <el-form-item label="所属经销商" class="h-elformWrap-2 w-elformWrap" v-if="f.oneLid && f.oneLid.startsWith('SD')">
                                                <el-select v-model="f.agent" multiple remote filterable :filter-method="queryUser" clearable placeholder="请输入"
                                                           :remote-method="queryUser" style="width: 90%">
                                                    <el-option v-for="(item) in agentList"
                                                               :key="item.usercode"
                                                               :label="item.username"
                                                               :value="item.usercode">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>



                                            <el-form-item label="区域" class="h-elformWrap-2 w-elformWrap" prop="areacodelist"   >
                                                <el-checkbox :disabled="updateFlag"  @change="selectAll">全选</el-checkbox>
                                                <div style="margin: 15px 0;"></div>
                                                <el-checkbox-group v-model="f.areacodelist" >
                                                    <el-checkbox v-for="item in options" :label="item.value" :key="item.value" :disabled="updateFlag" >{{item.label}}</el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveS">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import salesList from "../../api/loud/fanli/salesList";

    export default {
        data() {
            return {
                //带线表单
                f: {
                    areacodelist:[],
                    isFw:0,
                },
                LevelName: [],
                rules: {
                    prodcode: [{required: true, message: '请填写产品编码', trigger: 'blur'}],
                   /* prodstatus: [{required: true, message: '请选择状态', trigger: 'change'}],*/
                    protype: [{required: true, message: '请选择型号属性', trigger: 'change'}],
                    companycode: [{required: true, message: '请选择公司名称', trigger: 'change'}],
/*
                    factory: [{required: true, message: '请选择产地名称', trigger: 'change'}],
*/
                    validperiod: [{required: true, message: '请选择有效期', trigger: 'blur'}],
    /*                xiaoe: [{required: true, message: '请选择是否计算销额', trigger: 'change'}],
                    jishu: [{required: true, message: '请选择是否计算返利基数', trigger: 'change'}],*/
                    lianqun: [{required: true, message: '请选择链群', trigger: 'change'}],
                    have6858: [{required: true, message: '请选择是否覆盖6858', trigger: 'change'}],
                    have6840: [{required: true, message: '请选择是否覆盖6840', trigger: 'change'}],
                    have6854: [{required: true, message: '请选择是否覆盖6854', trigger: 'change'}],
                    three6840: [{required: true, message: '请选择是否覆盖6840', trigger: 'change'}],
                    areacodelist: [{required: true, message: '请选择区域', trigger: 'change'}],
                    isFw:[{required: true, message: '请选择是否服务', trigger: 'change'}],
                },
                wuliao: [],
                queryq: {
                    oneLid: '',
                    materialCode:'',
                },
                options: [],
                fwList:[
                    {code:1,name:"是"},
                    {code:0,name:"否"}
                ],
                updateFlag:false,
                agentList:[],
            }
        },
        created() {
            this.showLevelName();

            //初始化内销区域
            var area = this.$store.getters.dictlist("YlSalesArea_chanpin");
            for (var i = 0; i < area.length; i++) {
                var opt = {
                    value: area[i].code,
                    label: area[i].name
                };
                //不是9开头表示内销区域
                if(opt.value.substring(0, 1) != "9"){
                    this.options.push(opt)
                }

            }
        },
        methods: {
            //查询经销商
            queryUser(v){
                var q = {
                    ddlx:'1',
                    usercodename:null,
                }
                q.usercodename = v;
                ss.selectUserAgent.selectUserAgentList(q).then(rd=>{
                    this.agentList = rd;
                })
            },

            selectAll(v) {
                if(v){
                    this.f.areacodelist = []
                    for (var i = 0; i < this.options.length; i++) {
                        this.f.areacodelist.push(this.options[i].value);
                    }
                }else{
                    this.f.areacodelist = []
                }

            },

            //产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            //返回
            backS() {
                this.$router.push({path: "/chanp/salesTable"});
            },
            //保存
            saveS() {
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.$msg.confirm("确认提交该销售样表?", () => {
                        for (var i = 0; i < this.LevelName.length; i++) {
                            if (this.LevelName[i].id == this.f.prodseries) {
                                this.f.oneLid = this.LevelName[i].id;
                                this.f.prodseries = this.LevelName[i].levelname;
                            }
                        }
                        this.f.areacode = this.f.areacodelist.join(",");
                        this.f.agent = (this.f.agent || []).join(",");
                        ss.salesList.saveS(this.f).then(rd => {
                            this.$router.push({path: "/chanp/salesTable"});
                        })
                    });
                }
            },

            selectModel(code) {
                ss.salesList.selectModel(code).then(rd => {
                    if(rd){
                        this.$msg.msgs("该物料在销售样表中已存在,样表信息将自动带出");
                        this.f = {...rd}
                        this.f.id='';
                        this.f.isFw = 0;
                        this.updateFlag = true;
                        this.$set(this.f,'areacodelist', rd.areacode.split(","));

                    }else{
                        this.f = {...rd,"prodcode": code, areacodelist: [],isFw: 0}
                        this.$refs.f.resetFields();
                        this.selectListByCode(code)
                    }
                })
            },
            //根据大类查询物料
            selectWuliao(oneLid) {
                this.queryq.oneLid = oneLid
                ss.chanpin.selectMdmWuliao(this.queryq).then(rd => {
                    console.log(this.queryq);
                    this.wuliao = rd;
                    this.$set(this.f,'promodel', '');
                    this.$set(this.f,'prodcode', '');
                })

            },
            clickmodel(model){
                var obj = {}
                obj = this.wuliao.find(function(item){
                    return item.materialDescrition === model
                })
                if(obj!=null){
                    this.f.prodcode = obj.materialCode
                }else{
                    this.f.prodcode = '';
                }
            },

            clickCode(code){
                var obj = {}
                obj = this.wuliao.find(function(item){
                    return item.materialCode === code
                })
                if(obj!=null){
                    this.f.promodel = obj.materialDescrition;
                }else{
                    this.f.promodel = '';
                }
            },

            //根据根据编码查询物料信息
            selectListByCode(code) {
                this.queryq.materialCode = code
                ss.chanpin.selectListByCode(this.queryq).then(rd => {
                    if(rd){
                        this.f.promodel = rd.materialDescrition;
                        this.f.xiaoe = rd.xiaoe;
                        this.f.jishu = rd.jishu;
                        this.f.factory = rd.factory;
                        this.f.userCode = rd.userCode;

                        if(rd.materialType=='HAWA'){
                            this.f.protype='OEM'
                        }else if (rd.materialType=='FERT' || rd.materialType=='ROH' || rd.materialType=='HALB'){
                            this.f.protype='自产'
                        }
                        for (var i = 0; i < this.LevelName.length; i++) {
                             if (rd.productHierarchy.startsWith(this.LevelName[i].id)){
                                this.f.oneLid = this.LevelName[i].id;
                                this.f.prodseries = this.LevelName[i].levelname;
                            }
                        }
                    }else{
                        this.$msg.msge("物料编码错误！");
                        this.f.promodel = '';
                        this.f.oneLid ='';
                        this.f.prodseries ='';
                    }
                    this.$forceUpdate();
                })


            },


        }
    }
</script>
<style>
    .Yangbiao .h-elformWrap-2 .el-form-item__label {
        width: 45%;
        text-align: right;
    }

    .Yangbiao .el-form-item__content {
        width: 55%;
    }

    .Yangbiao .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }
    .Yangbiao .w-elformWrap {
        width: 100% !important;
    }
    .w-elformWrap .el-form-item__label {
        width: 14% !important;
    }
    .w-elformWrap .el-form-item__content {
        width: 86% !important;
    }
    .Yangbiao .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__label {
        width: 14%;
    }

    .Yangbiao .h-elformWrap-1 .el-form-item__content {
        width: 86%;
    }

    .Yangbiao.el-form-item__content .el-select {
        width: 100%;
    }
</style>
